export class PrePostQuestionSearchModel {
  sharedVehicleGroupHashId: string;
  companyHashId: string = "";
  instanceHashId: string = "";
  startDateTime: string = "";
  endDateTime: string = "";
  vehicleHashIdList: string[] = [];
  driverHashIdList: string[] = [];
  searchLicenceTagList: string[] = [];
  searchDriverNameList: string[] = [];
  searchCompanyList: string[] = [];
  companyHashIdList: string[] = [];
  searchSVGNameList: string[] = [];
  sharedVehicleGroupHashIdList: string[] = [];
  questionTypeList: number[] = [1,2,3,4];
  questionHashId: string = "";
  questionName: string = "";
  questionType: number;
  instanceName: string = "";
  companyName: string = "";
  svgName: string = "";
  vehicleName: string = "";
  driverName: string = "";
  answerDate: string;
  driverHashId: string = "";
  vehicleHashId: string = "";
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/pre-post-trip-question-overview/models/pre-post-question-search.model.ts